const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBiReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.883,
    height: 20,
    viewBox: "0 0 25.883 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M23.53 20H2.353A2.355 2.355 0 0 1 0 17.647V2.353A2.355 2.355 0 0 1 2.353 0H23.53a2.355 2.355 0 0 1 2.353 2.353v15.294A2.355 2.355 0 0 1 23.53 20zM12.941 2.353v15.294H23.53V2.353zm9.412 11.765h-8.236v-1.766h8.236v1.764zm0-2.941h-8.236V9.412h8.236v1.763zm0-2.941h-8.236V6.471h8.236v1.763z",
    style: {
      fill: "#002d72"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiReports);
export default __webpack_public_path__ + "static/media/BIReports.3dd14a8fefa62826a2f3e3ee28fa8dd4.svg";
export { ForwardRef as ReactComponent };